@if (open) {
  <div class="modal-backdrop job-modal-backdrop" role="presentation">
    <section class="modal-panel job-form-panel" role="dialog" aria-modal="true" aria-label="Job form">
      <header class="job-modal-header">
        <h2>{{ job ? 'Edit Job' : 'Create Job' }}</h2>
        <button type="button" class="job-close-button" (click)="closed.emit()" aria-label="Close">×</button>
      </header>

      <form [formGroup]="form" (ngSubmit)="save()" class="form-grid">
        <label class="full-row">
          <span>TOPS Job Number</span>
          <input formControlName="jobNumber" placeholder="TOPS job number" [readonly]="!!job" [attr.aria-readonly]="!!job" />
        </label>

        <label class="full-row">
          <span>Address*</span>
          <input formControlName="address" placeholder="Property address" required [readonly]="!!job" [attr.aria-readonly]="!!job" />
          @if (form.controls.address.touched && form.controls.address.invalid) {
            <small class="field-error">Address is required.</small>
          }
        </label>

        <label class="full-row">
          <span>Report Type</span>
          <select formControlName="reportType">
            <option value="">Select report type</option>
            @for (reportType of reportTypeOptions; track reportType) {
              <option [value]="reportType">{{ reportType }}</option>
            }
          </select>
        </label>

        <label class="full-row">
          <span>Appointment</span>
          <div class="appointment-row">
            <input formControlName="appointment" placeholder="DD-MM-YYYY HH:mm" />
            <button type="button" class="now-button" (click)="setAppointmentNow()">Now</button>
          </div>
        </label>

        <footer class="job-modal-footer full-row">
          <button type="button" class="cancel-button" (click)="closed.emit()">Cancel</button>
          <button type="submit" class="submit-button" [disabled]="submitting || form.invalid">
            {{ submitting ? 'Saving...' : (job ? 'Update Job' : 'Create Job') }}
          </button>
        </footer>
      </form>
    </section>
  </div>
}
